import React from "react";

import { Text } from "@chakra-ui/react";

import DocLink from "@/components/shared/DocLink";

export default function SecureDatasetsContent() {
  return (
    <>
      <Text mb={4}>
        Instant Datasets will automatically provision a database connected to the internet and secured by a
        password. This method may not be secure enough for you and so we have several recommendations on how
        to setup your data access for seamless yet secure access.
      </Text>
      <DocLink route="datasetsSecurity" text="Learn more about securing your Datasets" />
    </>
  );
}
